import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FiberManualRecordIcon(props: IconProps) {
    return <Icon {...props} iconKey={"fiber_manual_record"}/>
}
